import { NextSeo } from 'next-seo'

import protectedRoute from '@/utils/protected-route'

import Tabs from '../components/tabs'
import Links from './components/links'

const Overview = () => {
  return (
    <div className='align-center flex h-[100%] min-h-full  flex-wrap  bg-theme-cream'>
      <NextSeo title='Overview' />
      <div className='custom-padding-h mx-auto mt-[40px] max-w-7xl flex-[0_0_100%] px-10 sm:mt-[100px]  sm:px-6'>
        <Tabs />
        <Links />
      </div>
    </div>
  )
}

export default protectedRoute(Overview)
